import NewsCarousel from "./NewsCarousel";

export default function News () {
    return (
        <section className="section">
            <div className="sectionHeader">
                <h1 className="sectionTitle">News</h1>
            </div>
            <NewsCarousel />
        </section>
    );
}
